export default __webpack_public_path__ + "static/media/logoNameWhite.4c1603ab.png";